import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "avatar-popup-shell" }
const _hoisted_2 = {
  key: 0,
  class: "avatar-popup-shell__loading"
}
const _hoisted_3 = {
  key: 1,
  class: "avatar-popup-shell__interface"
}
const _hoisted_4 = { class: "avatar-popup-shell__stage" }
const _hoisted_5 = { class: "avatar-popup-shell__controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarPanel = _resolveComponent("AvatarPanel")!
  const _component_ControlsPanel = _resolveComponent("ControlsPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.bridgeReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 正在连接主窗口... "))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AvatarPanel, {
              "full-width": "",
              "is-agent-speaking": _ctx.bridgeState.isAgentSpeaking,
              "is-agent-thinking": _ctx.bridgeState.isAgentThinking,
              "avatar-image": _ctx.bridgeState.avatarImage
            }, null, 8, ["is-agent-speaking", "is-agent-thinking", "avatar-image"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["status-indicator", _ctx.bridgeState.connectStatus])
          }, _toDisplayString(_ctx.statusLabel), 3),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ControlsPanel, {
              "is-connected": _ctx.bridgeState.isConnected,
              "is-connecting": _ctx.bridgeState.isConnecting,
              "is-microphone-muted": _ctx.bridgeState.isMicrophoneMuted,
              "is-volume-muted": _ctx.bridgeState.isVolumeMuted,
              volume: _ctx.bridgeState.volume,
              "is-portrait-mode": false,
              onConnect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.invoke('connect'))),
              onDisconnect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.invoke('disconnect'))),
              onToggleMicrophone: _cache[2] || (_cache[2] = ($event: any) => (_ctx.invoke('toggleMicrophone'))),
              onToggleVolumeMute: _cache[3] || (_cache[3] = ($event: any) => (_ctx.invoke('toggleVolumeMute'))),
              onVolumeChange: _cache[4] || (_cache[4] = (value) => _ctx.invoke('volumeChange', value)),
              onInterrupt: _cache[5] || (_cache[5] = ($event: any) => (_ctx.invoke('interrupt'))),
              onSummarize: _cache[6] || (_cache[6] = ($event: any) => (_ctx.invoke('summarize'))),
              onLogout: _cache[7] || (_cache[7] = ($event: any) => (_ctx.invoke('logout')))
            }, null, 8, ["is-connected", "is-connecting", "is-microphone-muted", "is-volume-muted", "volume"])
          ])
        ]))
  ]))
}